import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Får jag erbjuda happy hour?";
const SHORT_ANSWER = "Ja, prissänkningar är tillåtna men inte 'oprovocerad alkoholförsäljning' (t.ex. tvåa för en, fritt sup till matgäst) som främjar överkonsumtion.";

export const Route = createFileRoute("/fraga/vad-galler-for-happy-hour")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Får jag erbjuda happy hour" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Reglerna finns i 7 kap. och 8 kap. alkohollagen samt Konsumentverkets vägledning. Du får sänka pris, men inte 'köp en, få en gratis' eller andra extrema former."}
      source={{ label: "Konsumentverket – Marknadsföring av alkohol", href: "https://www.konsumentverket.se/for-foretag/marknadsforing/marknadsforing-av-alkohol/" }}
      extraSources={[]}
      deepGuide={{ to: "/alkohollagen-kapitel-8", label: "Alkohollagen och happy hour" }}
      related={[{"to": "/fraga/far-jag-marknadsfora-alkohol-i-sociala-medier", "label": "Får jag marknadsföra alkohol på sociala medier?"}, {"to": "/fraga/far-jag-erbjuda-fri-alkohol-som-kampanj", "label": "Får jag bjuda gäster på alkohol som marknadsföring?"}, {"to": "/fraga/far-jag-salja-takeaway-vin-med-mat", "label": "Får jag sälja vin för avhämtning tillsammans med mat?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Får jag erbjuda happy hour?" },
      { name: "description", content: "Ja, prissänkningar är tillåtna men inte 'oprovocerad alkoholförsäljning' (t.ex. tvåa för en, fritt sup till matgäst) som främjar överkonsumtion." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-galler-for-happy-hour" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-galler-for-happy-hour" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-galler-for-happy-hour",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Får jag erbjuda happy hour", url: "https://alkoholprovet.se/fraga/vad-galler-for-happy-hour" },
      ]),
    ],
  }),
});
